/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import StatsCard from "../../Cards/statsCard";
import { CARD_GAP, REFETCH_CONFIGURATION } from "../../../utils/constants";
import CustomerBreakDownChart from "../../Charts/CustomerBreakdown";
import FinancialPerformanceChart from "../../Charts/FinancialPerformance";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useEffect, useState } from "react";
import ExpectedRevenueBySite from "../../Charts/RevenueByDistrict";
import { useUtils } from "../../../customHooks/useUtils";
import { formatCustomDateDayMonthYear } from "../../../utils/utils";
// import TransformerPerformance from "../../Charts/TransfomerPerformance";
import PowerConsumptionBySite from "../../Charts/PowerConsumptionBySite";
import { setStartDate } from "../../../store/filterSlice";
import Loader from "../../feedBacks/loader";

function FinanceHome({ company_id }: { company_id: string }) {
  const { mapResponseToLabelValue, FEEDBACK_MESSAGES, t, INSTATAENOUS_KPIS } =
    useUtils();
  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(false);
  const [isDateInitialized, setIsDateInitialized] = useState(false);
  const dispatch = useAppDispatch();

  const excludeCards = [t("readings.unknown")];
  const language = useAppSelector((state) => state.language.language);

  // Initialize date FIRST
  useEffect(() => {
    dispatch(setStartDate({ isFromFinance: true }));
    setIsDateInitialized(true);
  }, [dispatch]);

  useEffect(() => {
    setIsFirstTimeLoad(true);
  }, []);

  const startDate = useAppSelector((state) => state.filter.startDate);
  const endDate = useAppSelector((state) => state.filter.endDate);

  //  useFetchData is DISABLED until date is ready
  const {
    data,
    isLoading: isDataLoading,
    error,
    refetch,
  } = useFetchData(
    ["/finance", "fetchFinanceHome", company_id, startDate, endDate],
    "/finance/cards-data",
    {
      card_type: "finance_home",
      company_id,
      start_date: startDate,
      end_date: endDate,
      compare_with_previous_month: isFirstTimeLoad,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
      enabled: isDateInitialized && !!startDate && !!endDate, // ✅ Key fix
    }
  );

  const isLoading = isDataLoading || isLocalLoading;

  // 🔥 Only refetch when dates are ready
  useEffect(() => {
    if (isDateInitialized && startDate && endDate) {
      setIsLocalLoading(true);
      refetch().finally(() => setIsLocalLoading(false));
    }
  }, [isDateInitialized, startDate, endDate, refetch]);

  const transformedData = data ? mapResponseToLabelValue(data) : [];

  const renderStatsCards = (dataSlice: any[], noOfLoadBox: number) => {
    if (isLoading) {
      return Array.from({ length: noOfLoadBox }).map((_, index) => (
        <StatsCard
          key={`loading-${index}`}
          title=""
          value=""
          isError={false}
          isLoading={true}
        />
      ));
    }

    if (error) {
      if ((error as any).response?.data?.detail) {
        return Array.from({ length: 4 }).map((_, index) => (
          <StatsCard
            key={index}
            title=""
            value=""
            errorType={FEEDBACK_MESSAGES.NO_DEVICE}
            isError={true}
            isLoading={false}
            cardErrorStyle="!h-[50px]"
          />
        ));
      }
      return Array.from({ length: 4 }).map((_, index) => (
        <StatsCard
          key={`error-${index}`}
          title=""
          value=""
          isError={true}
          isLoading={false}
          cardErrorStyle="!h-[50px]"
        />
      ));
    }

    return dataSlice.map((statsData: any, index: number) => {
      if (excludeCards.includes(statsData.label)) return null;

      const prevKey = `previous_${statsData.key}`;
      const previousMonthValue = (data as any)[prevKey] ?? null;

      return (
        <div key={`stat-${index}`}>
          <StatsCard
            title={statsData.label}
            value={statsData.value as string}
            isError={false}
            isLoading={false}
            time={
              INSTATAENOUS_KPIS.includes(statsData.label)
                ? (statsData as any).time
                : ""
            }
            period={
              !INSTATAENOUS_KPIS.includes(statsData.label)
                ? formatCustomDateDayMonthYear(startDate, endDate, language)
                : ""
            }
            previousMonthValue={previousMonthValue}
            currency={(data as any).currency}
          />
        </div>
      );
    });
  };

  // Early return if date not ready
  if (!isDateInitialized || !startDate || !endDate) {
    return (
      <div className="w-full flex place-items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <div
      className="flex flex-col items-start justify-center w-full"
      style={{ gap: CARD_GAP }}
    >
      {/* stats wrapper */}
      <div
        className="grid w-full"
        style={{
          gap: CARD_GAP,
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        }}
      >
        {renderStatsCards(transformedData, 4)}
      </div>

      {/* charts wrapper */}
      <div
        className="flex flex-wrap justify-center w-full"
        style={{ gap: CARD_GAP }}
      >
        <FinancialPerformanceChart
          queryKey={["finance", "fetchFinancialPerformance", company_id]}
          route={`/finance/monthly-collection-billing`}
          params={{ company_id }}
        />
      </div>

      <div
        className="flex flex-wrap justify-center w-full"
        style={{ gap: CARD_GAP }}
      >
        <CustomerBreakDownChart company_id={company_id} />
        <ExpectedRevenueBySite
          company_id={company_id}
          startDate={startDate}
          endDate={endDate}
        />
      </div>

      {/* Transformer Performance and Consumption Trend */}
      <div
        className="flex flex-wrap justify-center w-full"
        style={{ gap: CARD_GAP }}
      >
        {/* <TransformerPerformance
          company_id={company_id}
          startDate={startDate}
          endDate={endDate}
        /> */}
        <PowerConsumptionBySite
          company_id={company_id}
          startDate={startDate}
          endDate={endDate}
        />
      </div>
    </div>
  );
}

export default FinanceHome;
